export const TheNFTAddress = "0x213BB84755532473bB26A5965e5E5c23cAa2496D";
